<template>
    <div>

        <centered-card>
            <div v-if="!isLoggedIn">
                <login/>
            </div>
            <div v-else>
                <post-form :savedMethod="afterSave"/>
            </div>


        </centered-card>
    </div>
</template>

<script>

    import CenteredCard from '../layout/CenteredCard.vue';
    import CenteresLogo from '../layout/CenterLogo.vue';
    import Login from '../user/LoginForm.vue';
    import PostForm from '../posts/AddPostForm.vue';

    import Favlet from '../ui/ShareBookmarklet.vue';


    export default {
        name: '',
        metaInfo: {
          title: 'Share on Pimblr'
        },
        data() {
            return {}
        },
        computed: {
            isLoggedIn(){
                return this.$store.getters['user/isLoggedIn'];
            }
        },
        methods: {
            afterSave(){
                window.close();
            }
        },
        components:{
            Login,
            PostForm,
            CenteredCard,
            CenteresLogo,
            Favlet,
        }
    }
</script>

<style lang="sass" scoped>
    .main
        margin-top: 20px
</style>


// WEBPACK FOOTER //
// src/components/posts/SharePage.vue